import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-split-view',
  templateUrl: './split-view.html',
  styleUrl: './split-view.scss',
})
export class SplitView {
  public readonly isCollapsed = input(false);
}
